<template>
  <div class="card">
    <h6>YOUR CURRENT ENERGY SUPPLY</h6>
    <h4>What would you like a quote for?</h4>

    <div class="row">
      <div class="col-xs-12 col-sm-4">
        <div class="suppliers-card" :class="{ active: showGasElectricity() }">
          <radio-button v-model="quote.compareFuel" value="gasElectricity" :error="$v.compareFuel.$error"
            @change="setDefaults">Gas & Electricity (Dual)</radio-button>

          <div v-show="showGasElectricity()">
            Your property {{ isQuoteParamsJourney == true ? ' new ' : '' }} has {{ dualIsPrepayment ? 'prepayment' : 'both' }} gas and electricity supply and your energy
            is currently provided by

            <div class="_margin-top-10">
              <div class="company-logo-xs" v-if="supplier.gas && quote.sameSupplier == 'no'">
                <div class="company-logo" :class="`supplier-${supplier.gas}`"></div>
              </div>

              <div class="company-logo-xs" v-if="supplier.electricity && quote.sameSupplier == 'no'">
                <div class="company-logo" :class="`supplier-${supplier.electricity}`"></div>
              </div>

              <div class="company-logo-xs" v-if="supplier.both && quote.sameSupplier == 'yes'">
                <div class="company-logo" :class="`supplier-${supplier.both}`"></div>
              </div>

              <div class="company-logo-xs" v-if="supplier.both && quote.sameSupplier == 'yes'">
                <div class="company-logo" :class="`supplier-${supplier.both}`"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xs-12 col-sm-4">
        <div class="suppliers-card"
          :class="{ active: supplier.electricity && quote.compareFuel == 'electricity' && defaultFuel == 'electricity' || quote.compareFuel == 'electricity' && defaultPrepaymentMismatch }">
          <radio-button v-model="quote.compareFuel" value="electricity" :error="$v.compareFuel.$error"
            @change="setDefaults">Electricity Only</radio-button>

          <div
            v-if="supplier.electricity && quote.compareFuel == 'electricity' && defaultFuel == 'electricity' || quote.compareFuel == 'electricity' && defaultPrepaymentMismatch">
            <div class="_margin-bottom-10">
              Your property {{ isQuoteParamsJourney == true ? ' new ' : '' }} has {{ quote.electricityCurrentPayMethod == 'prePaymentMeter' ? 'a prepayment' : 'an' }}
              electricity supply and your energy is currently provided by
            </div>

            <div class="company-logo-xs">
              <div class="company-logo" :class="`supplier-${supplier.electricity}`"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xs-12 col-sm-4">
        <div class="suppliers-card"
          :class="{ active: supplier.gas && quote.compareFuel == 'gas' && defaultFuel == 'gas' || quote.compareFuel == 'gas' && defaultPrepaymentMismatch }">
          <radio-button v-model="quote.compareFuel" value="gas" :error="$v.compareFuel.$error" @change="setDefaults">Gas
            Only</radio-button>

          <div
            v-show="supplier.gas && quote.compareFuel == 'gas' && defaultFuel == 'gas' || quote.compareFuel == 'gas' && defaultPrepaymentMismatch">
            <div class="_margin-bottom-10">
              Your property {{ isQuoteParamsJourney == true ? ' new ' : '' }} has a {{ quote.gasCurrentPayMethod == 'prePaymentMeter' ? 'prepayment' : '' }} gas supply
              and your energy is currently provided by
            </div>

            <div class="company-logo-xs">
              <div class="company-logo" :class="`supplier-${supplier.gas}`"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <uiv-alert class="_margin-top-30" type="info" v-if="$v.compareFuel.prepaymentMismatch == false">
      It looks as though one of your energy meters is prepayment. You will need to quote your gas and electricity
      separately.
    </uiv-alert>
  </div>
</template>

<script>
import RadioButton from '../../../../base/components/forms/RadioButton';

import { mapState, mapActions, mapGetters } from 'vuex';

export default {
  name: 'Compare',
  props: {
    $v: Object,
  },
  computed: {
    ...mapState({
      isQuoteParamsJourney: ({session}) => session.quoteParams.isQuoteParamsJourney,
      appSettings: ({ app_settings }) => app_settings,
      defaultSupplierId: ({ app_settings }) => app_settings.defaultSupplierId,
      quote: ({ quote }) => quote,
      defaultFuel: ({ quote }) => {
        if (quote.address.parts) {
          return quote.address.parts.fuelType;
        }

        return null;
      },
      dualIsPrepayment: ({ quote }) => {
        if (quote.compareFuel != 'gasElectricity') return false;
        if (quote.sameSupplier == 'yes') {
          return quote.currentPayMethod == 'prePaymentMeter';
        }

        return quote.gasCurrentPayMethod == 'prePaymentMeter' && quote.electricityCurrentPayMethod == 'prePaymentMeter';
      },
      supplier: ({ quote }) => {
        if (!quote.address.parts) {
          return { gas: null, electricity: null, both: null };
        }

        let { gasdetails, elecdetails } = quote.address.parts;
        gasdetails = gasdetails.find(({ isDomestic }) => isDomestic) || {};
        elecdetails = elecdetails.find(({ isDomestic }) => isDomestic) || {};

        return {
          gas: gasdetails.mugSupplierId,
          electricity: elecdetails.mugSupplierId,
          both: quote.sameSupplier == 'yes' ? gasdetails.mugSupplierId : null
        };
      },
      defaultPrepaymentMismatch: ({ quote }) => {
        if (!quote.address.parts) return false;
        let { gasdetails, elecdetails, fuelType } = quote.address.parts;

        gasdetails = gasdetails.find(({ isDomestic }) => isDomestic) || {};
        elecdetails = elecdetails.find(({ isDomestic }) => isDomestic) || {};

        const types = [gasdetails.isPrepayment, elecdetails.isPrepayment];

        if (fuelType == 'gasElectricity' && types.indexOf(true) > -1) {
          return gasdetails.isPrepayment != elecdetails.isPrepayment;
        }

        return false;
      },
    })
  },
  watch: {
    isQuoteParamsJourney (newValue) {
      if (newValue == true) {
          // Only if quote params journey start
          this.updateDefaultSupplier();
        }
    }
  },
  methods: {
    ...mapActions({
      getSuppliers: 'lookups/getSuppliers',
    }),
    showGasElectricity() {
      if (this.quote.compareFuel != 'gasElectricity') return false;
      if (this.quote.sameSupplier == 'no') {
        return this.supplier.gas && this.supplier.electricity;
      } else {
        return this.quote.supplierId;
      }
    },
    setDefaults() {
      let { gasdetails, elecdetails } = this.quote.address.parts;
      gasdetails = gasdetails.find(({ isDomestic }) => isDomestic) || {};
      elecdetails = elecdetails.find(({ isDomestic }) => isDomestic) || {};

      if (this.isQuoteParamsJourney == true) {
        if (this.quote.compareFuel == 'gasElectricity') {
          this.quote.supplierId = gasdetails.mugSupplierId || elecdetails.mugSupplierId || this.defaultSupplierId;
          this.quote.gasSupplierId = gasdetails.mugSupplierId || this.defaultSupplierId;
          this.quote.electricitySupplierId = elecdetails.mugSupplierId || this.defaultSupplierId;
          this.quote.address.parts.gasdetails.mugSupplierId = this.quote.address.parts.gasdetails.mugSupplierId || this.defaultSupplierId;
          this.quote.address.parts.elecdetails.mugSupplierId = this.quote.address.parts.elecdetails.mugSupplierId || this.defaultSupplierId;
        }

        if (this.quote.compareFuel == 'gas') {
          this.quote.supplierId = gasdetails.mugSupplierId || elecdetails.mugSupplierId || this.defaultSupplierId;
          this.quote.gasSupplierId = gasdetails.mugSupplierId || this.defaultSupplierId;
          this.quote.address.parts.gasdetails.mugSupplierId = this.quote.address.parts.gasdetails.mugSupplierId || this.defaultSupplierId;
        }

        if (this.quote.compareFuel == 'electricity') {
          this.quote.supplierId = elecdetails.mugSupplierId || elecdetails.mugSupplierId || this.defaultSupplierId;
          this.quote.electricitySupplierId = elecdetails.mugSupplierId || this.defaultSupplierId;
          this.quote.address.parts.elecdetails.mugSupplierId = this.quote.address.parts.elecdetails.mugSupplierId || this.defaultSupplierId;
        }
      }

      const twoSuppliers = gasdetails.mugSupplierId != null && elecdetails.mugSupplierId != null;
      this.quote.supplierId = gasdetails.mugSupplierId || elecdetails.mugSupplierId;
      this.quote.gasUsage.usage = gasdetails.mpaq;
      this.quote.gasUsage.usageType = 1;
      this.quote.gasUsage.usageUnit = 1;
      this.quote.electricityUsage.usageType = 1;
      this.quote.electricityUsage.usageUnit = 1;
      this.quote.currentPayMethod = 'monthlyDirectDebit';
      this.quote.electricityCurrentPayMethod = 'monthlyDirectDebit';
      this.quote.gasCurrentPayMethod = 'monthlyDirectDebit';
      this.supplier.gas = gasdetails.mugSupplierId;
      this.supplier.electricity = elecdetails.mugSupplierId;
      this.quote.electricitySmartMeterInstalled = elecdetails.isSmartMeter;
      this.quote.gasSmartMeterInstalled = gasdetails.isSmartMeter;
      this.quote.newTariffPaymentMethod = 'monthlyDirectDebit';
      this.quote.sameSupplier = gasdetails.mugSupplierId == elecdetails.mugSupplierId ? 'yes' : 'no';
        if (this.quote.compareFuel == 'gasElectricity' && gasdetails.mugSupplierId && !elecdetails.isDomestic) {
          this.quote.sameSupplier = 'yes';
          this.quote.supplierId = gasdetails.mugSupplierId;
          this.quote.electricitySupplierId = gasdetails.mugSupplierId;
          this.supplier.electricity = gasdetails.mugSupplierId;
        }
      this.quote.electricityUsage.disabledUnits = false;
      this.quote.heatingFuel = null;
      this.quote.cookingFuel = null;

      if (this.quote.compareFuel == 'gasElectricity' && this.quote.sameSupplier == 'yes') {
        if (elecdetails.isPrepayment == true && gasdetails.isPrepayment == true) {
          this.quote.currentPayMethod = 'prePaymentMeter';
          this.quote.newTariffPaymentMethod = 'prePaymentMeter';
        }
      }

      if ((this.quote.compareFuel == 'gasElectricity' && this.quote.sameSupplier == 'no') || this.quote.compareFuel == 'gas') {
        if (gasdetails.isPrepayment == true) {
          this.quote.gasCurrentPayMethod = 'prePaymentMeter';
          this.quote.newTariffPaymentMethod = 'prePaymentMeter';
        }
      }

      if ((this.quote.compareFuel == 'gasElectricity' && this.quote.sameSupplier == 'no') || this.quote.compareFuel == 'electricity') {
        if (elecdetails.isPrepayment == true) {
          this.quote.electricityCurrentPayMethod = 'prePaymentMeter';
          this.quote.newTariffPaymentMethod = 'prePaymentMeter';
        }
      }

      if (this.quote.compareFuel == 'electricity') {
        this.quote.heatingFuel = 2;
        this.quote.cookingFuel = 2;
        return this.getSuppliers('electricity');
      }

      if (this.quote.compareFuel == 'gas') {
        return this.getSuppliers('gas');
      }

      if (this.quote.compareFuel == 'gasElectricity' && this.quote.sameSupplier == 'yes') {
        this.quote.electricityUsage.disabledUnits = true;
        this.getSuppliers(this.quote.compareFuel);
      } else {
        this.getSuppliers('gas');
        this.getSuppliers('electricity');
      }
      this.updateDefaultSupplier();
    },
    async updateDefaultSupplier() {
      // default if supplier id not found then set British gas by default
      this.quote.supplierId = this.quote.supplierId || this.defaultSupplierId;
      this.supplier.gas = this.supplier.gas || this.defaultSupplierId;
      this.supplier.electricity = this.supplier.electricity || this.defaultSupplierId;
      if (this.quote.sameSupplier == 'yes') {
        this.supplier.both = this.supplier.both || this.defaultSupplierId;
      }
    }
  },
  components: {
    RadioButton
  }
};
</script>

<style lang="scss">
.suppliers-card {
  border: 2px solid transparent;
  border-radius: 10px;

  .company-logo-xs {
    position: relative;
    height: 40px;
    width: 50%;
    display: inline-block;

    .company-logo {
      position: absolute;
      top: 0;
      left: 0;
      transform: scale(0.7);
      -ms-transform-origin: 0 0;
      transform-origin: 0 0;
      overflow: hidden;
      border-color: #b0b0b0;
    }
  }

  &.active {
    padding: 15px;
    border: 2px solid $brand-colour-primary;
  }

  @media (max-width: 767px) {
    &.active {
      padding: 5px;
    }
  }
}
</style>
